<template>
  <div class="archivesWater">
    <div class="div-fixed">
      <div class="header">
        <h1 class="title">年次レポート / {{ year }} 年 / 水</h1>
      </div>
      <div class="button-area">
        <span class="btn-submit" @click="prev">戻る</span>
      </div>
      <select v-model="selectRange" @change="updateRange">
        <option
          v-for="range in displayRange"
          v-bind:key="range.key"
          v-bind:value="range.value"
        >
          {{ range.display }}
        </option>
      </select>
    </div>
    <div class="chart-container">
      <div id="chart-layoutx1">
        <div class="chart-area">
          <p class="ic-thermo">水位</p>
          <LineChart
            class="chart-container-canvas"
            ref="lineChartTemp"
            v-if="loadedWaterTemp"
            :chartData="chartdataWaterTemp"
            :options="optionsWaterTemp"
          ></LineChart>
        </div>
        <div class="chart-area">
          <p class="ic-water-temp">水温</p>
          <LineChart
            class="chart-container-canvas"
            ref="lineChartWater"
            v-if="loadedWaterLevel"
            :chartData="chartdataWaterLevel"
            :options="optionsWaterLevel"
          ></LineChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LineChart from "@/components/WeatherChartLine.vue";
import Loader from "@/mixins/loader";

export default {
  components: {
    LineChart,
  },

  mixins: [Loader],

  props: {
    year: {
      type: Number,
      default: () => {
        return new Date().getFullYear();
      },
    },
    historyIdxList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      selectRange: 0,
      displayRange: [
        { key: 0, value: 0, display: "年間", from: 0, to: 0 },
        { key: 1, value: 1, display: "1月", from: 0, to: 0 },
        { key: 2, value: 2, display: "2月", from: 0, to: 0 },
        { key: 3, value: 3, display: "3月", from: 0, to: 0 },
        { key: 4, value: 4, display: "4月", from: 0, to: 0 },
        { key: 5, value: 5, display: "5月", from: 0, to: 0 },
        { key: 6, value: 6, display: "6月", from: 0, to: 0 },
        { key: 7, value: 7, display: "7月", from: 0, to: 0 },
        { key: 8, value: 8, display: "8月", from: 0, to: 0 },
        { key: 9, value: 9, display: "9月", from: 0, to: 0 },
        { key: 10, value: 10, display: "10月", from: 0, to: 0 },
        { key: 11, value: 11, display: "11月", from: 0, to: 0 },
        { key: 12, value: 12, display: "12月", from: 0, to: 0 },
      ],
      loadedWaterTemp: false,
      loadedWaterLevel: false,
      allData: {
        labels: [],
        labelsMonth: [],
        chartDataSets: [],
      },

      chartdataWaterTemp: {
        labels: [],
        datasets: [],
        // datasets: [
        //   {
        //     label: "水位（cm）",
        //     data: [],
        //     fill: false,
        //     type: "line",
        //     lineTension: 0,
        //     borderWidth: 1,
        //     backgroundColor: "rgba(10, 150, 70, 0.3)",
        //     borderColor: "rgba(10, 150, 70, 0.5)",
        //     pointBackgroundColor: "rgba(0, 0, 0, 0)",
        //     pointBorderColor: "rgba(0, 0, 0, 0)",
        //     pointHoverBackgroundColor: "rgba(10, 150, 70, 0.5)",
        //   },
        // ],
      },

      chartdataWaterLevel: {
        labels: [],
        datasets: [],
        // datasets: [
        //   {
        //     label: "水温（℃）",
        //     data: [],
        //     fill: false,
        //     type: "line",
        //     lineTension: 0,
        //     borderWidth: 1,
        //     backgroundColor: "rgba(10, 150, 70, 0.3)",
        //     borderColor: "rgba(10, 150, 70, 0.5)",
        //     pointBackgroundColor: "rgba(0, 0, 0, 0)",
        //     pointBorderColor: "rgba(0, 0, 0, 0)",
        //     pointHoverBackgroundColor: "rgba(10, 150, 70, 0.5)",
        //   },
        // ],
      },
      optionsWaterTemp: {
        responsive: true,
        maintainAspectRatio: false,
        // height: "250px",
        legend: {
          display: true,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ cm ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                // beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
                // min: "8/3"
              },
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      },
      optionsWaterLevel: {
        responsive: true,
        maintainAspectRatio: false,
        // height: "250px",
        legend: {
          display: true,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ ℃ ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
                // autoSkip: true,
                // minTicksLimit: 24,
                // maxTicksLimit: 24,
              },
              // barPercentage: 1, //棒グラフ幅
              // categoryPercentage: 1, //棒グラフ幅
              // id: 'bar-axes-X',
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      },
    };
  },

  mounted() {
    this.loading(() => {
      try {
        this.createData();
      } catch (e) {
        console.log(e);
      }
    });
  },

  methods: {
    ...mapGetters(["getSensorDataHistories"]),

    /** 1年間分のデータを作成 */
    createData() {
      const historiesAll = this.getSensorDataHistories();
      const histories = [];
      // this.historyIdxList.forEach((el) => {
      //   histories.push(historiesAll[el]);
      // });
      // 同一のセンサーIDごとにデータをまとめる
      historiesAll.forEach((el) => {
        if (histories[el.sensor_id]) {
          histories[el.sensor_id].push(el);
        }
        else {
          histories[el.sensor_id] = [];
          histories[el.sensor_id].push(el);
        }
      });

      // ラベルの作成とデータ取得
      let dayCount = 0;
      for (var month = 1; month < 13; month++) {
        let dt = new Date(this.year, month, 0);
        let dtMonth = dt.getMonth() + 1;

        // ラベル配列中の月ごとの区切り箇所を記録
        const days = dt.getDate();
        this.displayRange[dtMonth]["from"] = dayCount;
        // 1日に表示するデータは0時と12時の2つにする
        dayCount += days * 2;
        this.displayRange[dtMonth]["to"] = dayCount;

        // ラベルの作成とチャートデータ構造作成
        for (var day = 1; day <= days; day++) {
          // 0時と12時のデータのみ使用する
          const dayStr = dtMonth + "/" + day;
          this.allData.labels.push(dayStr);
          this.allData.labels.push(dayStr);
          this.allData.labelsMonth.push(dayStr + " 00:00");
          this.allData.labelsMonth.push(dayStr + " 12:00");
        }
      }

      /** チャートデータ取得 */
      // 取得データを月日時毎に分割して保持し直す
      this.allData.chartDataSets = [];
      for (const histData of histories) {
        let chartDataSet = {
          rowData: histData,
          chartData: this.createInitialChartData(),
          waterLevelDatas: [],
          waterTempDatas: [],
        };
        // for (const sensorData of histData.sensor_datas) {
        //   let received_time = new Date(sensorData.datetime);
        //   chartDataSet.chartData[received_time.getMonth() + 1][
        //     received_time.getDate()
        //   ][received_time.getHours()] = sensorData;
        // }
        let received_time = new Date(histData.datetime);
        chartDataSet.chartData[received_time.getMonth() + 1][
            received_time.getDate()
          ][received_time.getHours()] = histData;

        this.allData.chartDataSets.push(chartDataSet);
      }

      this.displayRange[0]["from"] = 0;
      this.displayRange[0]["to"] = dayCount;

      // 0時と12時のデータを設定する
      this.allData.chartDataSets.forEach((el) => {
        let endDate = new Date(this.year, 12, 0, 0, 0, 0, 0);
        for (
          var dateCount = new Date(this.year, 0, 1, 0, 0, 0, 0);
          dateCount.getTime() < endDate.getTime();
          dateCount.setDate(dateCount.getDate() + 1)
        ) {
          const data0 =
            el.chartData[dateCount.getMonth() + 1][dateCount.getDate()][0];
          if (data0) {
            el.waterLevelDatas.push(data0.water_level);
            el.waterTempDatas.push(data0.water_temp);
          } else {
            // データが無くてもその日のデータをnullとして挿入する
            el.waterLevelDatas.push(null);
            el.waterTempDatas.push(null);
          }
          const data12 =
            el.chartData[dateCount.getMonth() + 1][dateCount.getDate()][12];
          if (data12) {
            el.waterLevelDatas.push(data12.water_level);
            el.waterTempDatas.push(data12.water_temp);
          } else {
            // データが無くてもその日のデータをnullとして挿入する
            el.waterLevelDatas.push(null);
            el.waterTempDatas.push(null);
          }
        }
      });

      // グラフで使用する色を生成
      const cols = [];
      cols[0] = "rgba(10, 150, 70, 0.5)";
      cols[1] = "rgba(90, 30, 233, 0.5)";
      cols[2] = "rgba(233, 30, 99, 0.5)";
      for (
        let i = 0, len = cols.length;
        i < this.allData.chartDataSets.length - len;
        i++
      ) {
        cols.push(this.createColor());
      }

      // 表示用データに詰め込む
      this.chartdataWaterTemp.labels = this.allData.labels;
      for (let i = 0; i < this.allData.chartDataSets.length; i++) {
        const el = this.allData.chartDataSets[i];
        let wkName = el.rowData.tag_no;
        if (el.rowData.name) {
          wkName += "(" + el.rowData.name + ")";
        }
        this.chartdataWaterTemp.datasets.push({
          label: wkName,
          data: el.waterTempDatas,
          fill: false,
          type: "line",
          lineTension: 0,
          borderWidth: 2,
          backgroundColor: cols[i],
          borderColor: cols[i],
          pointBackgroundColor: "rgba(0, 0, 0, 0)",
          pointBorderColor: "rgba(0, 0, 0, 0)",
          pointHoverBackgroundColor: cols[i],
        });
      }
      // this.loadedWaterTemp = true;

      this.chartdataWaterLevel.labels = this.allData.labels;
      for (let i = 0; i < this.allData.chartDataSets.length; i++) {
        const el = this.allData.chartDataSets[i];
        let wkName = el.rowData.tag_no;
        if (el.rowData.name) {
          wkName += "(" + el.rowData.name + ")";
        }
        this.chartdataWaterLevel.datasets.push({
          label: wkName,
          data: el.waterLevelDatas,
          fill: false,
          type: "line",
          lineTension: 0,
          borderWidth: 2,
          backgroundColor: cols[i],
          borderColor: cols[i],
          pointBackgroundColor: "rgba(0, 0, 0, 0)",
          pointBorderColor: "rgba(0, 0, 0, 0)",
          pointHoverBackgroundColor: cols[i],
        });
      }
      // this.loadedWaterLevel = true;

      // 当月を初期表示
      const nowDate = new Date();
      this.selectRange = nowDate.getMonth() + 1;
      this.updateRange(false);
    },

    /** グラフに表示しているデータ範囲を切り替える */
    updateRange(updateChartFlg = true) {
      let from = this.displayRange[this.selectRange]["from"];
      let to = this.displayRange[this.selectRange]["to"];

      this.loadedWaterTemp = false;
      // ラベル
      if (this.selectRange === 0) {
        this.chartdataWaterTemp.labels = this.allData.labels.slice(from, to);
      } else {
        this.chartdataWaterTemp.labels = this.allData.labelsMonth.slice(
          from,
          to
        );
      }
      // データ
      for (let cnt = 0; cnt < this.chartdataWaterTemp.datasets.length; cnt++) {
        this.chartdataWaterTemp.datasets[cnt].data = this.allData.chartDataSets[
          cnt
        ].waterTempDatas.slice(from, to);
      }
      // チャート更新
      if (updateChartFlg) {
        this.$refs.lineChartTemp.updateChart(this.chartdataWaterTemp);
      }
      this.loadedWaterTemp = true;

      this.loadedWaterLevel = false;
      // ラベル
      if (this.selectRange === 0) {
        this.chartdataWaterLevel.labels = this.allData.labels.slice(from, to);
      } else {
        this.chartdataWaterLevel.labels = this.allData.labelsMonth.slice(
          from,
          to
        );
      }
      // データ
      for (let cnt = 0; cnt < this.chartdataWaterLevel.datasets.length; cnt++) {
        this.chartdataWaterLevel.datasets[cnt].data =
          this.allData.chartDataSets[cnt].waterLevelDatas.slice(from, to);
      }
      // チャート更新
      if (updateChartFlg) {
        this.$refs.lineChartWater.updateChart(this.chartdataWaterLevel);
      }
      this.loadedWaterLevel = true;
    },

    createInitialChartData() {
      let chartData = {};
      // ラベルの作成とチャートデータ構造作成
      for (var month = 1; month < 13; month++) {
        let dt = new Date(this.year, month, 0);
        let dtMonth = dt.getMonth() + 1;

        // ラベル配列中の月ごとの区切り箇所を記録
        const days = dt.getDate();

        // ラベルの作成とチャートデータ構造作成
        chartData[dtMonth] = {};
        for (var day = 1; day <= days; day++) {
          chartData[dtMonth][day] = {};
          // 0時と12時のデータのみ使用する
          chartData[dtMonth][day][0] = {};
          chartData[dtMonth][day][12] = {};
        }
      }
      return chartData;
    },
    createColor() {
      return `rgba(${[
        this.randomNumber(0, 255),
        this.randomNumber(0, 255),
        this.randomNumber(0, 255),
        0.5,
      ].join(",")})`;
      // return `rgba(${[
      //   this.randomNumber(0, 255),
      //   this.randomNumber(0, 255),
      //   this.randomNumber(0, 255),
      //   (this.randomNumber(50, 100) * 0.01).toFixed(2),
      // ].join(",")})`;
    },

    randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    prev() {
      this.$router.push({ name: "archives-water" });
    },
  },
};
</script>

<style lang="scss">
.archivesWater {
  .div-fixed {
    z-index: 1;
    position: fixed;
    width: calc(100vw - 266px);
    background-color: #f0f3f5;
    border-bottom: 1px solid #bbb;
  }
  .header {
    margin: 2rem 2rem 1rem 2rem;
  }
  .button-area {
    width: auto;
    height: calc(100% - 130px);
    position: relative;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-bottom: 10px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 150px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }

  select {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 50px;
    border-radius: 10px;
    border: solid 1px var(--purple);
    padding: 0 38px 0 16px;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center;
    background-size: 25px 25px;
  }

  select:focus {
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center var(--purple-tertiary);
    background-size: 25px 25px;
  }

  .chart-container {
    width: auto;
    box-sizing: border-box;
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .chart-container-canvas {
    position: relative;
    // height: 250px;
    top: -10px;
  }
  .chart-date {
    font-weight: normal;
    font-size: 22px;
    margin: 0;
    padding: 0 0 30px 0;
  }
  .chart-date::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_cal.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 0 28px 0 0;
  }
  #chart-layoutx1 {
    display: grid;
    grid-template-columns: auto;
    width: 100%;
    box-sizing: border-box;
    padding-top: 150px;
  }

  #chart-layoutx2 {
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(400px, 2fr) minmax(350px, 1fr)
    );
    width: 100%;
    // justify-content: space-around;
    box-sizing: border-box;
  }

  #chart-layoutx3 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    width: 100%;
    box-sizing: border-box;
  }

  .chart-area {
    height: auto;
    // height: 250px;
    margin: 15px 0px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 5px rgb(0 0 0 / 0.1);
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .chart-area p {
    margin: 0px 0px 10px 0px;
    padding: 0;
    font-size: 20px;
  }
  .dashboard {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, max-content));
    justify-content: space-around;
    row-gap: 20px;
    column-gap: 50px;
  }
  .dashboard div {
    display: block;
    width: 180px;
    box-sizing: border-box;
    position: relative;
  }
  .dashboard p {
    text-align: center;
    color: #000;
  }
  ul {
    margin: 0;
    padding: 0;
  }
  .pieChart {
    display: block;
    width: 200px; // 180
    height: 220px; // 220
    margin: 10px auto 0;
    position: relative;
    box-sizing: border-box;
    // padding-top: 100px;
    padding-top: 120px;
    text-align: center;
    color: #fdab57;
    font-size: 20px;
  }
  .pieChart span {
    display: block;
    font-size: 56px;
    font-weight: 500;
    color: #fdab57;
    position: absolute;
    // top: 60%;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .pieChart canvas {
    position: absolute;
    // top: 65%;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -55%);
  }

  /* チャート拡大 */

  #chart-bass {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    background: rgba(0, 0, 0, 0.9);
    width: 100%;
    height: 100vh;
    z-index: 3;
    padding: 60px;
  }
  #chart-bass-frame {
    width: 100%;
    height: 100%;
    padding: 30px;
    border-radius: 20px;
    background: #fff;
  }

  #chart-bass-frame .info {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: top;
  }

  #chart-bass-frame .info p {
    font-size: 20px;
    margin: 0;
    padding: 0 0 20px 15px;
  }

  #chart-bass-frame .info span {
    font-size: 18px;
    margin: 0;
    padding: 0 0 0 20px;
  }

  #closeBtn {
    display: block;
    width: 30px;
    height: 30px;
    background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
    background-size: 30px 30px;
    cursor: pointer;
    transition: 0.1s;
  }
  #closeBtn:active {
    transform: scale(0.9);
    opacity: 0.8;
  }

  #chart-bass.active {
    display: block;
    animation: showChart 0.3s ease 0s;
  }

  #chart-bass .chart-container-canvas {
    position: relative;
    /* width: 100%; */
    height: 80%;
  }

  #chart-bass .calBtn {
    display: block;
    margin: 30px 20px;
    text-align: right;
    color: black;
    cursor: pointer;
    font-size: 14px;
    transition: 0.5s;
  }

  #chart-bass .calBtn::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_cal.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 13px 0 0;
  }

  #chart-bass .calBtn:hover {
    color: #666;
  }

  @keyframes showChart {
    from {
      transform: scale(0.5);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* アイコン */

  .ic-chart {
    display: block;
  }
  .ic-chart::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_chart.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 15px;
  }

  .ic-thermo {
    display: block;
  }
  .ic-thermo::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_water_temp.svg") no-repeat center center;
    background-size: 35px 35px;
    padding: 10px;
  }

  .ic-water-temp {
    display: block;
  }
  .ic-water-temp::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_thermometer.sun.svg") no-repeat center
      center;
    background-size: 35px 35px;
    padding: 10px;
  }
}
</style>
